import TablePluginSetup from "./table/PluginSetup.js";
import DetailPluginSetup from "./detail/PluginSetup.js";
export default {
  install: molten => {
    TablePluginSetup.install(molten);
    DetailPluginSetup.install(molten);
  }
};